import { combineReducers } from 'redux';
import dataReducer from './dataReducer';
import surveyReducer from './surveyReducer';

const allReducers = combineReducers({
    dataReducer,
    surveyReducer
});

export default allReducers;



// WEBPACK FOOTER //
// ./application/reducers/index.js